module.exports = __webpack_public_path__ + "img/188.problem_water_bar.f4a1d028.svg";